<template>
  <div class="hisdata-base">
    <div class="search-wrap">
      <slot name="search"></slot>
    </div>
    <el-row :gutter="20">
      <el-col :span="8">
        <div class="top">
          <div class="title">
            <slot name="l-t-title"></slot>
          </div>
          <div class="content">
            <slot name="l-t-content"></slot>
          </div>
        </div>
        <div class="bottom">
          <div class="title">
            <slot name="l-b-title"></slot>
          </div>
          <div class="content">
            <slot name="l-b-content"></slot>
          </div>
        </div>
      </el-col>
      <el-col :span="16">
        <div class="title">
          <slot name="r-title"></slot>
        </div>
        <div class="content">
          <slot name="r-content"></slot>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss">
.hisdata-base {
  height: 100%;
  .el-row {
    height: calc(100% - 62px);
    .el-col {
      height: 100%;
    }
  }
  .top,
  .bottom {
    height: 50%;
  }
  .title {
    height: 60px;
    line-height: 60px;
    font-size: 22px;
    font-weight: 700;
    color: #0ef;
  }
  .content {
    height: calc(100% - 60px);
    max-height: calc(100% - 60px);
    overflow: hidden;
    border-radius: 10px;
    background-color: #121e2c;
  }
}
</style>
